import { render } from "./InfestationIcon.vue?vue&type=template&id=638ff8e8"
import script from "./InfestationIcon.vue?vue&type=script&lang=js"
export * from "./InfestationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__